import React from 'react';
import { TableMenu } from '@gerdau/hefesto-mais-web';
import { Button as HefestoButton, Title } from '@gerdau/hefesto';
import { TableMenuContainer } from './styles';

interface ICheckoutTableHeaderProps {
  title: string;
  onEditClick(): void;
}

const CheckoutTableHeader: React.FC<ICheckoutTableHeaderProps> = ({
  title,
  onEditClick
}) => {
  return (
    <TableMenuContainer>
      <TableMenu
        leftComponents={<Title level={3}>{title}</Title>}
        rightComponents={
          <HefestoButton
            name="Edit"
            type="button"
            variant="secondary"
            onClick={onEditClick}
          >
            Editar
          </HefestoButton>
        }
      ></TableMenu>
    </TableMenuContainer>
  );
};

export default CheckoutTableHeader;
